import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_FILTERING_RULE: TypedDocumentNode<Data, Variables> = gql`
  query getFilteringRule($id: ID!) {
    node(id: $id) {
      ... on FilteringRule {
        applicableDomains
        blocked
        domainIds
        id
        name
      }
    }
  }
`
